import { formatUrlDate } from '@/utils/dateUtils';

export const formatRangeLabel = (range: {
    startDate: string;
    endDate: string;
}): string => `${formatUrlDate(range.startDate)} – ${formatUrlDate(range.endDate)}`;
